import {
    numberWithCommaWithoutDecimals,
    stringNumberFormatToSimpleNumber
  } from '@wiggot/utils/src/formatters'
  import Input from '@wiggui/ds/Input'
  import React, { ChangeEvent } from 'react'
  interface IProps {
    onInputPricesChange: ({ key, value }: { key: string; value: number }) => void
    prices: {
      priceFrom?: number
      priceTo?: number
    }
  }
  export const PriceInputs = ({ onInputPricesChange, prices }: IProps) => {
    const onInputNumberChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = target
      const formatValue = stringNumberFormatToSimpleNumber(value)
      onInputPricesChange({
        key: name,
        value: isNaN(formatValue) ? 0 : formatValue
      })
    }
    return (
      <>
        <Input
          className="w-full"
          classNameInput="w-full"
          classNameContainer="w-full"
          labelText="Desde"
          name="priceFrom"
          onChange={onInputNumberChange}
          rightText="MXN"
          value={
            numberWithCommaWithoutDecimals(prices?.priceFrom ?? 0, true) ?? 0
          }
          classNameLabel="text-secondary"
        />
        <Input
          className="w-full"
          classNameInput="w-full"
          classNameContainer="w-full"
          labelText="Hasta"
          name="priceTo"
          onChange={onInputNumberChange}
          rightText="MXN"
          value={numberWithCommaWithoutDecimals(prices?.priceTo ?? 0, true) ?? 0}
          classNameLabel="text-secondary"
        />
      </>
    )
  }
  